// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#140045","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#fff","menuHover":"var(--color-primary)","subMenuBg":"#fff","subMenuHover":"#31179D","sideBarWidth":"200px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 115